import { Component, OnInit, Inject, Input } from '@angular/core';
import { faPlus, faTimes, faExternalLink, faShare, faPencil } from '@fortawesome/pro-light-svg-icons';
import { AddPreInvoiceFeeComponent } from  './add-fee/add-pre-invoice-fee.component';
import { PreInvoiceFeesService } from '../../../shared/services/pre-invoice-fees.service';
import { SelectPreInvoiceFeeSupplierComponent } from './select-pre-invoice-fee-supplier/select-pre-invoice-fee-supplier.component';
import { environment } from 'src/environments/environment';
import { KlyantService } from 'src/app/shared/services/klyant.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'pre-invoice-fees',
  templateUrl: './pre-invoice-fees.component.html',
  styleUrls: ['./pre-invoice-fees.component.scss']
})
export class PreInvoiceFeesComponent implements OnInit {

  @Input() caseId : number;

  preInvoiceFees: any[] = [];
  supplierList: any[] = [];
  faPlus = faPlus;
  faTimes = faTimes;
  faShare = faShare;
  faPencil = faPencil;
  faExternalLink = faExternalLink;

  preInvoiceFeesNetTotal: number = 0;
  preInvoiceFeesVatTotal: number = 0;

  constructor(private preInvoiceFeesService: PreInvoiceFeesService,
              private klyantService: KlyantService,
              private toastService: ToastService,
              public modalService: ModalService,
              public activeModal: NgbActiveModal) {
    
  }

  ngOnInit(): void {

    this.loadPreInvoiceFees();

    this.klyantService.getSuppliers().subscribe((results) => {
      this.supplierList = results;
    });
  }

  getSupplierName(supplierId:number) {
    var supplier = this.supplierList.filter(x => x.id == supplierId);
    if(supplier && supplier.length == 1) {
      return supplier[0].name;
    }
    else {
      return null;
    }
  }

  loadPreInvoiceFees(){
    this.preInvoiceFeesService.getPreInvoiceFees(this.caseId).subscribe((response : any) => {
      this.preInvoiceFees = response.preInvoiceFees;
      this.preInvoiceFeesNetTotal = 0;
      this.preInvoiceFeesVatTotal = 0;
      this.preInvoiceFees.forEach((fee:any) => {
        this.preInvoiceFeesNetTotal += fee.netAmount;
        this.preInvoiceFeesVatTotal += fee.vatAmount;
      });
    });
  }

  addFee(){

    const modalRef = this.modalService.openWithOptions(AddPreInvoiceFeeComponent, { size: 'lg' });
                          
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
      (result) => {
        if(result)
        {
          this.loadPreInvoiceFees();
        }
      },
      () => {} // dismissed - do nothing
    );

  }

  editInKlyant(outlayId) {
    window.open(environment.klyant.guiBaseUrl + '/outlays/' + outlayId + '/edit', '_blank');
  }

  sendToKlyant(fee:any) {    
    var preInvoiceFeeId = fee.preInvoiceFeeId;
    fee.sendingToKlyant = true;
    this.klyantService.resendPreInvoiceFeeToKlyant(preInvoiceFeeId).subscribe({
        next: (response) => {
            fee.sendingToKlyant = false;
            this.toastService.success("Outlay added to Klyant");
            this.loadPreInvoiceFees();
        },
        error: (error) => {
            fee.sendingToKlyant = false;
            const message = error.error || "There was a problem adding the Outlay to Klyant";
            this.toastService.error(message);
        }
    });
}
  selectSupplierForFeeRow(preInvoiceFeeId:number) {

    const modalRef = this.modalService.openWithOptions(SelectPreInvoiceFeeSupplierComponent, { size: 'md' });
    modalRef.componentInstance.preInvoiceFeeId = preInvoiceFeeId;

    modalRef.result.then(
      (result) => {
        if(result)
        {
          this.loadPreInvoiceFees();
        }
      },
      () => {} // dismissed - do nothing
    );
  }

  removeFee(fee: any) {

    var popupText = '';
    if(fee.klyantOutlayId)
    {
      popupText = 'THIS ITEM HAS BEEN SENT TO KLYANT. YOU MUST VOID THE OUTLAY IN KLYANT MANUALLY.';
    }

    const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg' });
                          
    modalRef.componentInstance.messageHeader = 'Are you sure you want to remove this fee?';
    modalRef.componentInstance.popupText1 = popupText;
    modalRef.componentInstance.popupText2 = 'Any associated Invoice Items will also be deleted.';

    modalRef.result.then(
      (result) => {
        if(result)
        {
          this.preInvoiceFeesService.removePreInvoiceFee( this.caseId, fee.preInvoiceFeeId ).subscribe((response : any) => {
          this.loadPreInvoiceFees();
        });
        }
      },
      () => {} // dismissed - do nothing
    );

  }

}
